import { format, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Formata uma data de forma segura, verificando se é válida antes
 * @param {string|Date} date - A data para formatar
 * @param {string} formatString - O formato desejado (padrão: 'dd/MM/yyyy')
 * @param {object} options - Opções adicionais (como locale)
 * @param {string} fallback - Texto de fallback caso a data seja inválida
 * @returns {string} A data formatada ou o fallback
 */
export function safeFormatDate(date, formatString = 'dd/MM/yyyy', options = { locale: ptBR }, fallback = 'Data não disponível') {
  if (!date) return fallback;
  
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return fallback;
    
    return format(dateObj, formatString, options);
  } catch (error) {
    console.warn('Erro ao formatar data:', error);
    return fallback;
  }
}

/**
 * Verifica se uma data é válida
 * @param {string|Date} date - A data para verificar
 * @returns {boolean} True se a data é válida
 */
export function isValidDate(date) {
  if (!date) return false;
  
  try {
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
  } catch {
    return false;
  }
}

/**
 * Retorna o tempo decorrido entre a data e agora em formato amigável (ex: 'há 2 dias', '3 horas', '5 min')
 * @param {string|Date} date - Data de referência
 * @param {boolean} addSuffix - Se deve adicionar o sufixo (ex: 'há ...')
 * @returns {string} Tempo decorrido
 */
export function getTimeElapsedString(date, addSuffix = true) {
  if (!date) return 'Tempo desconhecido';
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return 'Tempo desconhecido';
    return formatDistanceToNow(dateObj, { locale: ptBR, addSuffix });
  } catch {
    return 'Tempo desconhecido';
  }
}

/**
 * Formatos de data mais comuns para usar com safeFormatDate
 */
export const DATE_FORMATS = {
  SHORT: 'dd/MM/yyyy',
  LONG: "dd 'de' MMMM 'de' yyyy",
  WITH_TIME: 'dd/MM/yyyy HH:mm',
  TIME_ONLY: 'HH:mm',
  ISO: 'yyyy-MM-dd',
  MONTH_YEAR: 'MMM yyyy',
  PRETTY: 'PPP',
  PRETTY_WITH_TIME: 'PPp'
}; 